export default __webpack_public_path__ + "static/media/news-4.ae0c1e7a.jpg";